<template lang="pug">
div.pad5
  app-collapse(:title="item.pessoa.pessoaFisica.nome" :collapsed="'1'" v-if="item.pessoa && socios && socios.length > 0"  v-for="(item, index) in socios" :key="item._id")
    p
      span.label Função:
      span.text &nbsp {{getFuncao(item.funcao, item.isSocioRepresentanteLegal)}}
    p
      span.label Nome:
      span.text &nbsp {{filterNull(item.pessoa.pessoaFisica.nome)}}
    p
      span.label CPF:
      span.text &nbsp {{filterNull(item.pessoa.pessoaFisica.cpf)}}
    p
      span.label RG:
      span.text &nbsp {{filterNull(item.pessoa.pessoaFisica.rg)}}
    p
      span.label Órgão expedidor:
      span.text &nbsp {{filterNull(item.pessoa.pessoaFisica.orgaoExpedidor.codigo)}}
    p
      span.label UF do RG:
      span.text &nbsp {{item.pessoa.pessoaFisica.orgaoExpedidor.estado || '-'}}
    p
      span.label Nacionalidade:
      span.text &nbsp {{filterNull(item.pessoa.pessoaFisica.nacionalidade)}}
    p
      span.label Estado civil:
      span.text &nbsp {{estadoCivilFormatado(item.pessoa.pessoaFisica.estadoCivil)}}
    p
      span.label Email:
      span.text &nbsp {{filterNull(item.pessoa.email)}}
    app-resumo-documentos(:documentos="item.documentos")
</template>
<script>
import estadosBr from '@/constants/estados'
import AppResumoDocumentos from './AppResumoDocumentos'
import AppCollapse from '@/components/AppCollapse'

export default {
  components: {
    AppResumoDocumentos,
    AppCollapse
  },
  props: {
    socios: {
      Type: Object,
      required: true
    }
  },
  data () {
    return {
      estadosBr
    }
  },
  methods: {
    filterNull (atributo) {
      return atributo !== null ? atributo : '-'
    },
    getEmail (interessado) {
      return interessado.email ? interessado.email : interessado.pessoaFisica.email ? interessado.pessoaFisica.email : '-'
    },
    getEstadoBySigla (sigla) {
      if (sigla) {
        const estado = this.estadosBr.filter((estado) => {
          return estado.codigo === sigla
        })
        return estado[0].nome
      }
      return '-'
    },
    estadoCivilFormatado (estadoCivil) {
      switch (estadoCivil) {
        case 'SOLTEIRO':
          return 'Solteiro'
        case 'CASADO':
          return 'Casado'
        case 'UNIAO_ESTAVEL':
          return 'União estável'
        case 'DIVORCIADO':
          return 'Divorciado'
        case 'VIUVO':
          return 'Viúvo'
        case 'SEPARADO':
          return 'Separado'
        case 'UNIAO_HOMOAFETIVA':
          return 'União homoafetiva'
        default:
          return '-'
      }
    },
    getFuncao (funcao, isRepresentanteLegal) {
      if (funcao === 'SOCIO' && isRepresentanteLegal) {
        return 'Socio/Representante Legal'
      }
      switch (funcao) {
        case 'SOCIO':
          return 'Socio'
        default:
          return 'Representante Legal'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.label {
  font-weight: bold;
  color: #606266;
}

.text {
  color: #696580;
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/retificacao/components/resumos/AppResumoSocios.vue